import { render, staticRenderFns } from "./3.vue?vue&type=template&id=15302536&scoped=true&"
import script from "./3.vue?vue&type=script&lang=js&"
export * from "./3.vue?vue&type=script&lang=js&"
import style0 from "./3.vue?vue&type=style&index=0&id=15302536&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15302536",
  null
  
)

export default component.exports